const round2 = (value) => Math.round(value * 100) / 100;

export const donutGeometry = ({ size = 160, stroke = 14 } = {}) => {
  const radius = (size - stroke) / 2;
  return {
    size,
    stroke,
    center: size / 2,
    radius,
    circumference: 2 * Math.PI * radius,
  };
};

export const dasharray = (percent, circumference) => {
  const value = Number(percent);
  const clamped = Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 0;
  const filled = round2((circumference * clamped) / 100);
  return `${filled} ${round2(circumference - filled)}`;
};

export const percentFromAmounts = (part, total) => {
  const whole = Number(total);
  const value = Number(part);
  if (!Number.isFinite(whole) || whole <= 0 || !Number.isFinite(value)) return null;
  return (value / whole) * 100;
};

export const percentLabel = (percent) => {
  const value = Number(percent);
  if (percent === null || percent === undefined || !Number.isFinite(value)) return "--";
  return `${Number(value.toFixed(2))}%`;
};
